import React, { useEffect } from 'react';

import { useTypedParams } from 'react-router-typesafe-routes';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { CallInfo, ParticipantsTable, CallsLister } from '../../components/Calls';
import CallInfoSkeleton from '../../components/Calls/CallInfoSkeleton';
import { CallNotFoundEmptyState } from '../../components/EmptyStates';
import { ROUTES } from '../../routes';
import useCallInfoBuilder from '../../hooks/useCallInfoBuilder';
import useParticipants from '../../hooks/useParticipants';
import useWarmTransfer from '../../hooks/useWarmTransfer';

export const CallDetailPageContent = () => {
  const { callId } = useTypedParams(ROUTES.call);

  const { callInfo, error, activeCall, status } = useCallInfoBuilder({
    callId: callId ? Number(callId) : undefined,
  });

  const { participants, participantsError } = useParticipants(activeCall, status);
  const { transferFeedback, handleWarmTransfer, clearFeedback } = useWarmTransfer(activeCall);

  useEffect(() => {
    if (activeCall) {
      clearFeedback();
    }
  }, [activeCall, clearFeedback]);

  const renderContent = () => {
    if (error) {
      return <CallNotFoundEmptyState />;
    }

    if (!callInfo.hasData()) {
      return <CallInfoSkeleton />;
    }

    return (
      <>
        <CallInfo data={callInfo} transferFeedback={activeCall ? transferFeedback : undefined} />
        {activeCall && participants.length > 1 && (
          <ParticipantsTable
            disableInvite={status !== 'open'}
            error={participantsError}
            onInviteAgent={handleWarmTransfer}
            participants={participants} />
        )}
      </>
    );
  };

  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.List>
          <CallsLister selectedCallId={callId ? Number(callId) : undefined} />
        </Layout.List>
        <Layout.Content>
          {renderContent()}
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};
